import { render, staticRenderFns } from "./reference.vue?vue&type=template&id=7c0a3b90&scoped=true"
import script from "./reference.vue?vue&type=script&lang=js"
export * from "./reference.vue?vue&type=script&lang=js"
import style0 from "./reference.vue?vue&type=style&index=0&id=7c0a3b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a3b90",
  null
  
)

export default component.exports